import React from "react";
import Breadcrumb from "../../../utils/Breadcrumb";
import { useStandard } from "../../../context/StandardContext";
import { Link, useParams } from "react-router-dom";
import DashboardChartView from "../../../components/View/DashboardChartView";
import DashboardChartViewLarge from "../../../components/View/DashboardChartViewLarge";
import DashboardCardView from "../../../components/View/DashboardCardView";

function StandardDashboard() {
  const { stdId } = useParams();
  const { standardName } = useStandard();

  return (
    <div className=" w-[92%] h-full mx-auto">
      {/* Header */}
      <div className=" flex justify-start items-center gap-x-6 mb-1 pt-1">
        <Breadcrumb
          items={[
            { name: "Standard" },
            { name: standardName },
            { name: "Dashboard" },
          ]}
        />

        {/* Page tabs next to breadcrumb */}
        <div className="flex items-center gap-x-1">
          <span className="text-[12px] font-semibold px-3 py-[3px] rounded-md border border-primary text-primary bg-[#F2E9FF]">
            Dashboard 1{/* Overview */}
          </span>
          <span className="text-[#6E6985] text-[12px]">/</span>
          <Link
            to={`/standard/${stdId}/dashboard/tables`}
            className="text-[12px] font-medium px-3 py-[3px] rounded-md border border-transparent text-[#6E6985] hover:border-primary hover:text-primary transition-colors"
          >
            Dashboard 2{/* Schedules &amp; MoM */}
          </Link>
        </div>

        <Link
          to="/main/progress"
          className="text-primary border border-primary px-3 py-[2px] text-[12px] font-medium rounded-md flex items-center ml-auto"
        >
          View Progress
        </Link>
      </div>

      <div className=" w-full grid grid-cols-12 gap-4">
        {/* ── Top row: 6 small doughnut charts ── */}
        <div className="col-span-12">
          <div className=" w-full grid grid-cols-12 gap-4">
            <div className="col-span-2">
              <DashboardChartView
                title="Implementation Checklist"
                path={`/standard/${stdId}/activity/implementation-checklist`}
                url={`/DashBoard/standard/${stdId}/implementation/`}
              />
            </div>
            <div className="col-span-2 col-start-3">
              <DashboardChartView
                title="Internal Audit Checklist"
                path={`/standard/${stdId}/activity/internal-audit-checklist`}
                url={`/DashBoard/standard/${stdId}/internal_audit/`}
              />
            </div>
            <div className="col-span-2 col-start-5">
              <DashboardChartView
                title="Maintenance"
                path={`/standard/${stdId}/activity/maintenance`}
                url={`/DashBoard/standard/${stdId}/maintenance/`}
              />
            </div>
            <div className="col-span-2 col-start-7">
              <DashboardChartView
                title="Master List of Documents"
                path={`/standard/${stdId}/activity/master-list-of-documents`}
                url={`/DashBoard/standard/${stdId}/master_list_of_document/`}
              />
            </div>
            <div className="col-span-2 col-start-9">
              <DashboardChartView
                title="Consent Management"
                path={`/standard/${stdId}/reference-doc/consent-management`}
                url={`/DashBoard/standard/${stdId}/consent_management_form/`}
              />
            </div>
            <div className="col-span-2 col-start-11">
              <DashboardChartView
                title="SLA Management"
                path={`/standard/${stdId}/information/sla-management`}
                url={`/DashBoard/standard/${stdId}/service_level/`}
              />
            </div>
          </div>
        </div>

        {/* ── Bottom row: large charts (side legends) + card widgets ── */}

        {/* Consent Type chart */}
        <div className="col-span-5 ">
          <DashboardChartViewLarge
            title="Consent Type"
            path={`/standard/${stdId}/reference-doc/consent-management`}
            url={`/DashBoard/standard/${stdId}/consent-distribution/`}
            filterKey="consentTypeFilter"
            legendItems={[
              {
                label: "Consent Given Minor",
                color: "#92D050",
                filter: "Consent Given Minor",
                apiKey: "consent_given_minor",
              },
              {
                label: "Consent Given Major",
                color: "#00B050",
                filter: "Consent Given Major",
                apiKey: "consent_given_major",
              },
              {
                label: "Consent Withdrawal Minor",
                color: "#FFC000",
                filter: "Consent Withdrawl Minor",
                apiKey: "consent_withdrawal_minor",
              },
              {
                label: "Consent Withdrawal Major",
                color: "#FF0000",
                filter: "Consent Withdrawl Major",
                apiKey: "consent_withdrawal_major",
              },
            ]}
          />
        </div>

        {/* SLA Compliant chart */}
        <div className="col-span-5 ">
          <DashboardChartViewLarge
            title="SLA Compliant"
            path={`/standard/${stdId}/information/sla-management`}
            url={`/DashBoard/standard/${stdId}/sla-distribution/`}
            filterKey="slaCompliantFilter"
            legendItems={[
              {
                label: "Yes",
                color: "#00B050",
                //  "#92D050",
                filter: "Yes",
                apiKey: "compliant_yes",
              },
              {
                label: "No",
                color: "#FF0000",
                filter: "No",
                apiKey: "compliant_no",
              },
            ]}
          />
        </div>

        {/* Card widgets column */}
        <div className="col-span-2 space-y-1">
          <div>
            <DashboardCardView
              title="Training Calendar"
              path={`/standard/${stdId}/information/training-calendar`}
              url={`/DashBoard/standard/${stdId}/training-calender/`}
            />
          </div>
          <div>
            <DashboardCardView
              title="Security Incident"
              path={`/standard/${stdId}/information/security-incident`}
              url={`/DashBoard/standard/${stdId}/security-incident/`}
            />
          </div>
          <div>
            <DashboardCardView
              title="Total Vendor"
              path={`/standard/${stdId}/information/vendor-management`}
              url={`/DashBoard/standard/${stdId}/vendor/`}
              cardName="vendor"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StandardDashboard;
